import { IconContent } from '../style';

const Add = () => (
  <IconContent fill='currentColor' viewBox='0 0 24 24'>
    <path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' />
  </IconContent>
);

export default Add;
